/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import Service from '@/pages/dashboard/components/PageContainer/Service';
import { BaseServiceComponentProps } from '@/pages/benchmark/types/commom';
import dateTimeFormat from '@home/utils/dbDataFormat/dateTimeFormat';
import { useParams } from 'umi';
import { getCompleteDateValue } from '@/pages/dashboard/utils/utils';
import { DATA_TYPE_OBJECT } from '@home/utils/common';
import { stringToFunction } from '@/pages/dashboard/utils/stringToJson';

export interface IStudioMetricCardServiceProps
  extends BaseServiceComponentProps {
  metrics: string[];
  gameCode: string;
  studioCode: string;
  [key: string]: any;
}

export interface ParamsType {
  studio_code: string;
  game_code?: string;
  start_time: string;
  end_time: string;
  metrics?: string[];
  filters: {
    campaign_name_list: string[];
    region_country_list: string[];
    channel_name_list: string[];
    fix_language_list: string[];
    platform_list: string[];
    content_list: string[];
    format_list: string[];
  };
}

export default function KolCardService(
  props: IStudioMetricCardServiceProps,
) {
  const {
    style,
    className,
    dataKey = 'kolData',
    api,
    children,
    filterVal,
    metrics,
    formatData,
    extraParams = {},
    filterLoading,
    data,
    ...resetProps
  } = props || {};

  const { studioId, gameCode} = useParams() || {} as any;
  const formatDataFunc = (data: any, filterVal: any) => {
    if (formatData) return stringToFunction(formatData)(data);
    const { list } = data;
    const {isSingle, date} = filterVal;
    const [_start_time, end_time] = date || [];
    const cardDate = isSingle ? end_time : 'TOTAL';
    // 格式化卡片数据，取接口日期为TOTAL的数据
    const card_list = list
      ?.filter((item: { date: string; }) => item.date === cardDate)
      .map((item: { metrics: { [key: string]: { value: string; }; }; }) => 
        Object.keys(item.metrics).map(key => ({
          metrics_name: key,
          value: item.metrics[key].value,
        }))
      )
      .flat();
    // 格式化卡片数据，去除接口日期为TOTAL的数据
    const trend_list = list
      ?.filter((item: { date: string; }) => item.date !== 'TOTAL')
      .map((item: { date: string; metrics: { [key: string]: { value: string; }; }; }) => ({
        date: item.date,
        metrics: item.metrics,
      }));
    
    return {
      card_list,
      trend_list,
    };
  };
  
  

  return (
    <div className={className} style={style}>
      <Service
        api={api}
        formatData={formatDataFunc}
        data={{ ...props.data }}
        dataKey={dataKey}
        filterLoading={filterLoading}
        filterVal={filterVal}
        beforeRequest={(data) => {
          const { filterVal } = data;
          const { date, isSingle, campaign_name, region_country, channel_name, fix_language, platform, content, format} = filterVal || {};
          const [start_time, end_time] = date || [];
          let startDate = dateTimeFormat(start_time, 'day');
          const rangeTime = [start_time, end_time];
          // const time_type = DATA_TYPE_OBJECT[date_type];
          // 补齐逻辑
          if (isSingle) {
            const rangeTimeArr = getCompleteDateValue(rangeTime, "day");
            startDate = dateTimeFormat(rangeTimeArr[0], 'day');
          }
          const params: ParamsType = {
            studio_code: studioId,
            game_code: gameCode || data?.frameCode,
            start_time: startDate,
            end_time: dateTimeFormat(end_time, 'day'),
            metrics,
            filters: {
              campaign_name_list: campaign_name,
              region_country_list: region_country?.market,
              channel_name_list: channel_name,
              fix_language_list: fix_language,
              platform_list: platform,
              content_list: content,
              format_list: format,
            },
          };
          return { ...params, ...extraParams };
        }}
        trackData={['gameCode', 'frameCode']}
      >
        {React.Children.map(children, (child: any) =>
          React.cloneElement(child, {
            ...(resetProps || {}),
          }),
        )}
      </Service>
    </div>
  );
}
